export const RESOURCE_ENDPOINTS = {
  COST_SHEET_TEMPLATE_LIST: 'resource_code_list/',
  COST_SHEET_TEMPLATE_DETAIL: (id: string) => `resource_code_list/${id}/`,
  COST_SHEET_TEMPLATE_LINKED_PROJECTS: (id: string) =>
    `resource_code_list/${id}/projects/`,
  COST_SHEET_TEMPLATE_CLONE: (id: string) =>
    `resource_code_list/${id}/clone_this_list/`,
  EXPORT_RESOURCE_COST_SHEET: (id: string) => `v1.1/resources/export/${id}/`,
  LIST_RESOURCE_COST_SHEET: 'v1.1/resources/list',
  RESOURCE_TYPE_DROPDOWN: 'v1.1/resources/dropdown/resource_type/',
  GET_GROUPED_RESOURCES: 'v1.1/resources/dropdown/get_grouped_resources/',
  ARCHIVE_RESOURCE_COST_SHEET: 'v1.1/resources/bulk_archive/',
  RESTORE_RESOURCE_COST_SHEET: 'v1.1/resources/bulk_restore/',
  BULK_DELETE_RESOURCE_COST_SHEET: 'v1.1/resources/bulk_delete/',
  EMPLOYEE_RATE_SHEET: '/resource_code_list/employee_rate_sheet/',
  GET_RESOURCE_DROPDOWN: '/v1.1/api-bills/dropdown/resources/',
  RESOURCE_LIBRARY_BULK_SAVE: 'v1.1/resources/library/bulk_save',
  GET_RESOURCE_DETAIL: (id: string) => `v1.1/resources/get/${id}/`,
  CREATE_RESOURCE: 'v1.1/resources/create/',
  EDIT_RESOURCE: (id: string) => `v1.1/resources/update/${id}/`,
  // RESOURCE_TYPE_DROPDOWN: 'v1.1/resources/dropdown/resource_type',
  LINKED_PROJECTS: 'v1.1/resources/linked_projects/',
  EXPORT_RESOURCE: 'v1.1/resources/export/',
};
